import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const activate = async (data = {}, params = {}) => request({
  path: "/client-activate",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
